import { render, staticRenderFns } from "./FormularioAnexar.vue?vue&type=template&id=63776428&scoped=true"
import script from "./FormularioAnexar.vue?vue&type=script&lang=js"
export * from "./FormularioAnexar.vue?vue&type=script&lang=js"
import style0 from "./FormularioAnexar.vue?vue&type=style&index=0&id=63776428&prod&style=true&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63776428",
  null
  
)

export default component.exports